// extracted by mini-css-extract-plugin
export default {"general":"premises_general__lIF4n"};